// ETL ワークフロー画面の共通ヘルパー・定数。
// ETLWorkflowPage / CreateWorkflowModal / WorkflowEditModal で共有して利用する。
// 通知のターゲット/テンプレート設定は、通知フローの設計が固まるまで一時的に非表示にする。
export const HIDE_NOTIFICATION_PLANNING_SETTINGS = true;
// 指定ステップがエージェント変換ステップかどうかを判定する。
export const isAgentTransformStep = (step) => step.step_kind === 'agent_transform' ||
    step.step_kind === 'agent_map_transform' ||
    (step.step_type === 'transform' && step.config?.agent_id);
// BigQuery SQL の入力チェック。susugi 側 ensure_read_only_select と同じ規則の早期フィードバック。
// 文字列リテラルは解析しないので、DML/スクリプトの最終判定は実行時の BigQuery dry run が行う。
export const validateBigQuerySql = (sql) => {
    // 1つの正規表現で先に現れたコメントから順に消す（susugi 側 _SQL_COMMENT と同じ）
    const stripped = sql.replace(/\/\*[\s\S]*?\*\/|--[^\n]*|#[^\n]*/g, ' ').trim();
    if (!stripped || stripped === ';') {
        return 'SQLクエリを入力してください';
    }
    if (!/^[\s(\uFEFF]*(select|with)(?![A-Za-z0-9_])/i.test(stripped)) {
        return 'SELECT文のみ実行可能です。SELECT または WITH で始まるクエリを入力してください。';
    }
    return null;
};
// ワークフローのステップ構成が V2 ウィザードで編集可能かどうかを判定する。
export const isWorkflowEditableByV2Steps = (steps = []) => {
    const supportedAgentSteps = steps.filter(isAgentTransformStep);
    const extractStep = steps.find((step) => step.step_kind === 'upload_file_extract' ||
        step.step_kind === 'kujyu_reports_extract' ||
        step.step_kind === 'bigquery_sql_extract');
    if (steps.length === 1) {
        return supportedAgentSteps.length === 1;
    }
    if (steps.length === 2 && supportedAgentSteps.length === 1) {
        const agentStep = supportedAgentSteps[0];
        const loadStep = steps.find((step) => step.step_kind === 'database_fallback_load');
        if (!loadStep || !Array.isArray(loadStep.depends_on)) {
            return false;
        }
        return loadStep.depends_on.length === 1 && loadStep.depends_on[0] === agentStep.step_id;
    }
    if (steps.length === 3 && supportedAgentSteps.length === 1 && extractStep) {
        const agentStep = supportedAgentSteps[0];
        const loadStep = steps.find((step) => step.step_kind === 'database_fallback_load');
        if (!Array.isArray(agentStep.depends_on) || !loadStep || !Array.isArray(loadStep.depends_on)) {
            return false;
        }
        // load は agent のみ、または agent + extract（BigQuery: 生データも最終結果に残す）に依存する
        const loadDeps = new Set(loadStep.depends_on);
        const loadDependsOnlyOnKnownSteps = loadDeps.has(agentStep.step_id) &&
            [...loadDeps].every((id) => id === agentStep.step_id || id === extractStep.step_id);
        return (agentStep.depends_on.length === 1 &&
            agentStep.depends_on[0] === extractStep.step_id &&
            loadDependsOnlyOnKnownSteps);
    }
    return false;
};
